// extracted by mini-css-extract-plugin
export default {"advertCardFooter":"c-a_iP","advertCardFooter__row":"c-a_iQ","advertCardFooter__name":"c-a_iR","advertCardFooter__price":"c-a_iS","advertCardFooter__age":"c-a_iT"};